import { produce } from 'immer';
import { initialResultsState } from '../state';
import {
  REMOVE_FILTER,
  RESET_FILTERS,
  RESET_SELECTION,
  SET_FILTER_PARAMS,
  SET_SELECTED,
  UPDATE_STATE,
} from '../actions';

export const dfReducer = produce((draft, action) => {
  switch (action.type) {
    case UPDATE_STATE: {
      draft.term = action.appState.term;
      draft.availableFilters = action.appState.availableFilters;
      draft.itemFilter = action.appState.itemFilter;
      draft.selected = action.appState.selected;
      draft.params = action.appState.params;
      break;
    }
    case SET_FILTER_PARAMS: {
      draft.itemFilter = action.filter;
      draft.shareIds = [];
      break;
    }
    case RESET_FILTERS: {
      draft.params = [];
      draft.selected = {};
      draft.itemFilter = {};
      break;
    }
    case RESET_SELECTION: {
      draft.params = [];
      draft.selected = {};
      break;
    }
    case REMOVE_FILTER: {
      const depthCheck = draft.params.find((param) => param.pimId === action.id);
      if (depthCheck) {
        draft.params = draft.params.filter((param) => param.depth < depthCheck.depth);
        draft.selected = draft.params.reduce(
          (previous, current) => ({
            ...previous,
            [current.depth]: current.pimId,
          }),
          {},
        );
      }
      break;
    }
    case SET_SELECTED: {
      if (draft.selected[action.depth] === action.id) {
        delete draft.selected[action.depth];
      } else {
        draft.selected[action.depth] = action.id;
      }
      Object.keys(draft.selected).forEach((depth) => {
        if (depth > action.depth) {
          delete draft.selected[Number(depth)];
        }
      });
      draft.params = Object.entries(draft.selected).map(([depth, pimId]) => ({
        depth: parseInt(depth, 10),
        pimId,
      }));
      draft.shareIds = [];
      break;
    }
  }
}, initialResultsState);
